import './BillingAutomation.scss';
import { JSX, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Page } from '@Components/Page';
import { useAppSelector } from '../../redux';
import { currentCompanySelector } from '../../redux/company';
import { emailSelector } from '../../redux/user';
import { BillingConfiguration } from './BillingConfiguration';
import { Invoices } from './Invoices';
import { SalesforceRelationships } from './SalesforceRelationships';

const BillingTab = {
  BILLING_CONFIGURATION: 'billingConfiguration',
  SALESFORCE_RELATIONSHIPS: 'salesforceRelationships',
  INVOICES: 'invoices'
} as const;
type BillingTab = (typeof BillingTab)[keyof typeof BillingTab];

const BILLING_TABS: { label: string; key: BillingTab }[] = [
  { label: 'Billing Sheets', key: BillingTab.INVOICES },
  { label: 'Billing Configuration', key: BillingTab.BILLING_CONFIGURATION },
  { label: 'Salesforce Relationship Mapping', key: BillingTab.SALESFORCE_RELATIONSHIPS }
];

export const BillingAutomation = () => {
  const company = useAppSelector(currentCompanySelector);
  const userEmail = useAppSelector(emailSelector);
  const [activeTab, setActiveTab] = useState<BillingTab>(BillingTab.INVOICES);

  const tabNav = (
    <Nav
      activeKey={activeTab}
      onSelect={key => key && setActiveTab(key as BillingTab)}
      className='billing-automation-tabs'
    >
      {BILLING_TABS.map(({ label, key }) => (
        <Nav.Item key={key}>
          <Nav.Link eventKey={key}>{label}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );

  const renderBody = (tab: BillingTab): JSX.Element => {
    switch (tab) {
      case BillingTab.BILLING_CONFIGURATION:
        return <BillingConfiguration key={company} company={company} userEmail={userEmail} />;
      case BillingTab.SALESFORCE_RELATIONSHIPS:
        return <SalesforceRelationships key={company} company={company} userEmail={userEmail} />;
      case BillingTab.INVOICES:
        return <Invoices key={company} company={company} userEmail={userEmail} />;
      default:
        return <div />;
    }
  };

  return (
    <Page title='Billing Automation' pageType='Billing Automation' subHeader={tabNav}>
      {renderBody(activeTab)}
    </Page>
  );
};
